import { REQUEST_DEPOSIT_MODAL, REQUEST_LOGIN_MODAL, REQUEST_APPLICATION_INSTALL_MODAL } from '../constants';

/**
 * type:event
 */
export const requestLoginModal = () => ({
  type: REQUEST_LOGIN_MODAL,
});
export const requestDepositModal = () => ({
  type: REQUEST_DEPOSIT_MODAL,
});
export const requestApplicationInstallModal = () => ({
  type: REQUEST_APPLICATION_INSTALL_MODAL,
});
